/* Ignite Sales */
import keymirror from 'keymirror';

const Actions = keymirror({
  APPOINTMENT_TIME_SELECTED: null,
  ZIPCODE_UPDATED: null,
  CONTACT_LEAD_UPDATED: null,
  CHANGE_CONTACT_SCREEN: null,
  MAP_LOCATION_SELECTED: null
});

export default Actions;



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/constants/Actions.js
 **/